import React, { useEffect, useState } from 'react';
import { Observer } from 'mobx-react';
import { AppBar, Tabs, Tab, Typography, Box } from '@material-ui/core';
import { css } from '@emotion/core';
import { useHistory, Link } from 'react-router-dom';
import XdAccountMapping from './XdAccountMapping';
import DxAccountMapping from './DxAccountMapping';

const Container = css`
  .MuiTab-root {
    max-width: 400px !important;
  }
`;

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  if (value !== index) return null;
  return (
    <Typography
      component="div"
      role="tabpanel"
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      <Box p={3}>
        <Typography variant="h3" style={{ textAlign: 'center' }}>
          Account Mapper
        </Typography>
        {children}
      </Box>
    </Typography>
  );
}

const ExtSysMapper = () => {
  const [value, setValue] = useState(0);
  return (
    <div css={Container}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={(e, newValue) => setValue(newValue)}
          aria-label="simple tabs example"
          indicatorColor="primary"
          centered
        >
          <Tab label="Accounting System → Deal Map" {...a11yProps(0)} />
          {/* <Tab label="Deal Map → Accounting System" {...a11yProps(1)} /> */}
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <XdAccountMapping />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <DxAccountMapping />
      </TabPanel>
    </div>
  );
};

export default ExtSysMapper;
